"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integerToBinary = integerToBinary;
exports.binaryToInteger = binaryToInteger;
function integerToBinary(value, padding = 0) {
    return value.toString(2).padStart(padding);
}
function binaryToInteger(value) {
    if (Number.isInteger(Number(value))) {
        return parseInt(value, 2);
    }
    return 0;
}
//# sourceMappingURL=binary.js.map